import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, List, Table } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { Scroll } from "../components/Animation";

const Edit = () => {
  return(
    <>
      <Head slug="edit"></Head>
      
      <div className="l-row">
        <Space size={['96px', '72px']}></Space>
        <Scroll state="left">
          <Texts slug={`page-edit/title`} class={''} />
        </Scroll>
        <Space size={['48px', '40px']}></Space>
        <Texts slug={`page-edit/body`} class={''} />

        <Space size={['80px 0 104px', '64px 0 80px']}>
          <div className="c-grid__repeat--3 c-grid__gap--60">
            <List Item={Item} length={3}></List>
          </div>
        </Space>
      </div>

      <Problem />

      <Price />

      <Space size={['80px', '64px']}></Space>
      <div className="l-row">
        <div className="p-box__edit--bottom">
          <div className="p-box__edit--bottom__inner">
            <Texts slug={`page-edit/bottom-title`} class={'c-text--white c-text--center'} />
            <Space size={['40px auto 0', '32px auto 0']}>
              <Texts slug={`page-edit/bottom-body`} class={'c-text--white'} />
            </Space>
          </div>
        </div>
      </div>
      <Space size={['200px', '120px']}></Space>
    </>
  )
};

export default Edit;

const Price = () => {
  return(
    <>
      <div className="p-box__wrap--about">
        <Space size={['160px', '120px']}></Space>
          <div className="l-row">
            <div className="c-grid__wrap--table">
              <div>
                <Texts slug={`title/price`} class={'c-text--main c-text--big c-text--en'} />
                <Space size={['64px 0 0', '48px 0 0']}>
                  <Texts slug={`price/title`} class={''} />
                </Space>
              </div>

              <Table slug="price" len={8}></Table>
            </div>
          </div>
        <Space size={['120px', '80px']}></Space>
      </div>
    </>
  )
}

const Problem = () => {
  const Item = (props) => {
    return(
      <>
        <Scroll>
          <div className="p-box__items--problem__page">
            <Texts slug={`page-edit/problem-list${props.index}`} class={'c-text--center'} />
          </div>
        </Scroll>
      </>
    )
  }

  return(
    <>
      <div className="p-box__wrap--problem">
        <Space size={['64px', '64px']}></Space>
        <div className="l-row">
          <Texts slug={`title/problem`} class={'c-text--center c-text--white c-text--en c-text--big'} />
          <Space size={['64px 0 0', '48px 0 0']}>
            <Texts slug={`page-edit/problem`} class={'c-text--center c-text--white'} />
          </Space>
          <Space size={['48px', '32px']}></Space>
          <div className="c-grid__repeat--4 c-grid__gap--24" data-state="problem">
            <List Item={Item} length={4}></List>
          </div>
        </div>
        <Space size={['64px', '48px']}></Space>
      </div>
    </>
  )
}

const Item = (props) => {
  return (
    <>
      <Scroll>
        <div>
          <Space size={['0 auto', '0 auto']}>
            <Media src={`reason/list${(props.index + 1)}`} alt={'media'} class={`p-img__reason`} />
          </Space>
          <Space size={['24px 0 32px', '24px 0 32px']}>
            <Texts slug={`page-edit/list-title${props.index}`} class={'c-text--center'} />
          </Space>
            <Texts slug={`page-edit/list-body${props.index}`} class={''} />
        </div>
      </Scroll>
    </>
  );
}
